/* eslint-disable guard-for-in */
/* eslint-disable no-nested-ternary */
import { get } from "lodash";
import moment from "moment";
import XLSX from "xlsx";
import { BASE_URL } from "../Constant";

export function timeChange(m, offset) {
  moment.updateLocale("en", {
    relativeTime: {
      future: "in %s",
      past: "%s ago",
      s(number) {
        return `${number < 10 ? "0" : ""}${number} sec`;
      },
      m: "01:00 mins",
      mm(number) {
        return `${(number < 10 ? "0" : "") + number} mins`;
      },
      h: "an hour",
      hh: "%d hours",
      d: "a day",
      dd: "%d days",
      M: "a month",
      MM: "%d months",
      y: "a year",
      yy: "%d years",
    },
  });
  const m1 = moment(m);

  return m1.subtract(offset, "ms").fromNow();
}
export function fetchTimeValue(value, timestamp1, timestamp2) {
  if (timestamp1 !== null || timestamp2 != null) {
    let result = "";

    if (value === "hr") {
      result = ((timestamp1 + timestamp2) / 3600000).toFixed(2);
    } else if (value === "min") {
      result = ((timestamp1 + timestamp2) / 60000).toFixed(2);
    } else if (value === "sec") {
      result = ((timestamp1 + timestamp2) / 1000).toFixed(2);
    }
    return result;
  }
  return "NA";
}

export function transformedText(text, search) {
  // eslint-disable-next-line no-useless-escape
  let pattern = search.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, "\\$&");
  pattern = pattern
    .split(" ")
    .filter((t) => t.length > 0)
    .join("|");
  const regex = new RegExp(pattern, "gi");
  return {
    __html: search
      ? text.replace(
        regex,
        (match) => `<span class="highlight">${match}</span>`,
      )
      : text,
  };
}

export function UpperCaseAtFirst(lower) {
  if (lower) return lower.charAt(0).toUpperCase() + lower.substr(1);
  return "";
}
export function regionExistIn(data, filterKey) {
  if (data) {
    return data.filter((dataItem) => dataItem === filterKey).length;
  }
  return 0;
}

export function filterData(data, key, filterKey) {
  return data.filter((item) => item[key].includes(filterKey));
}
export function convertIntoKm(value) {
  return (value / 1000).toFixed(2);
}

export function downloadExcel(data, fileName) {
  if (data && Array.isArray(data)) {
    const wb = XLSX.utils.book_new();
    wb.Props = {
      Title: `Error_${fileName}`,
    };
    wb.SheetNames.push("Error Sheet");
    data.unshift({
      date: "Travel Date",
      busNumber: "Bus Number",
      distance: "Settlement Distance",
      date_error: "Date error",
      bus_error: "Bus number error",
      distance_error: "Distance error",
      data_error: "Data error",
    });
    const ws = XLSX.utils.json_to_sheet(data, { skipHeader: true });
    ws["!cols"] = [
      { wch: 16 },
      { wch: 15 },
      { wch: 24 },
      { wch: 15 },
      { wch: 20 },
      { wch: 20 },
      { wch: 15 },
    ];
    wb.Sheets["Error Sheet"] = ws;
    XLSX.writeFile(wb, `Error_${fileName}`);
  }
}

// TODO: This can be removed in future after all the exports are chnaged to new method.
const createFormAndSubmit = ({ uriProps }) => {
  const form = document.createElement("form");
  form.setAttribute("method", "POST");
  form.setAttribute("action", `${BASE_URL}`);
  // eslint-disable-next-line no-restricted-syntax
  for (const paramName in uriProps) {
    const paramValue = uriProps[paramName];
    const inputElm = document.createElement("input");
    inputElm.setAttribute("name", paramName);
    inputElm.setAttribute("value", paramValue);
    inputElm.setAttribute("type", "hidden");
    form.appendChild(inputElm);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

export const exportExcel = async (params) => {
  const { id, addOnFilter } = params;
  const query = {
    platform: "web",
    timezoneOffset: -330,
    id,
    paramValue: JSON.stringify({
      query: {
        id,
        addOnFilter,
      },
    }),
    token: localStorage.getItem("token"),
  };
  createFormAndSubmit({ uriProps: query });
};

export const handleDatesChange = (params) => {
  const { dates, props } = params;
  if (dates.startDate && dates.endDate) {
    const fromDate = parseFloat(new Date(dates.startDate).getTime());
    const toDate = parseFloat(new Date(dates.endDate).getTime());
    props?.selectDateFilter({ fromDate, toDate });
  }
};

export const getListUtil = (params) => {
  const {
    dispatchFn, props = {}, state = {}, extraParam = "",
  } = params;

  const payLoad = {
    pageNo: state?.pageNo,
    pageSize: state?.rowsPerPage,
    searchString: props?.searchString,
    sortBy: state?.sortBy,
    operatorFilter: props?.operatorFilter || props.operator,
    cityFilter: props?.cityFilter || props.city,
    dateFilter: {
      fromDate: new Date(get(props, "location.state.fromDate", null)).getTime(),
      toDate: new Date(get(props, "location.state.toDate", null)).getTime(),
    },
    cityId: get(props, "location.state.cityId", ""),
    agencyId: get(props, "location.state.agencyId", ""),
    contractType: state.contractType,
  };

  if (extraParam) {
    dispatchFn(payLoad, extraParam);
  } else {
    dispatchFn(payLoad);
  }
};

export const fetchCityAndOperator = (params) => {
  // let cities = [];
  if (params.navLoader === 0) {
    params.dayWiseBreakDownView(true);
    // params?.navData?.cities?.forEach((id) => cities.push(parseInt(id,10)));
    // params.fetchCities({cityIds: cities || []});
    // params.fetchCityOperators({
    //   cityIdArr: params.navData.cities || [] ,
    //   operatorIdArray: params.navData.operators || []
    // });
  }
};
